import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Kostenlose Spiele Online Spielen Ohne Anmeldung | Gamezop',
  desc: 'Kostenlose Spiele Online ohne Anmeldung Deutsch bei Gamezop spielen. Mehr als 200 online spiele umsonst, darunter Action, Abenteuer, Arcade, Puzzle, Rennen und mehr.',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Kostenlose Spiele Online Spielen Ohne Anmeldung',
    body: {
      text: [
        `Spiele kostenlose Online-Spiele auf Gamezop, ohne Download!
Wähle dein Lieblingsspiel aus unserer Liste und starte innerhalb von Sekunden. Wir haben über 200+ beliebte kostenlose Spiele in Kategorien wie Action, Abenteuer, Arcade, Puzzle, Rennen und mehr. Egal, ob du auf Handy, PC oder iOS spielst, Gamezop hat die besten Spiele für dich.`,
        `Wenn dir langweilig ist, bietet Gamezop endlose Unterhaltungsmöglichkeiten. Baue Verteidigungen gegen Feinde, schieße auf Ziele oder springe über Hindernisse. Spiele spannende Spiele wie Kingdom Fight, City Cricket, Fruity Fiesta und viele mehr! Unsere Spiele sind für Kinder, Erwachsene und Senioren gleichermaßen geeignet.`,
        `Du brauchst kein High-End-Gerät zum Spielen. Unsere Spiele laufen ohne Installation oder Download – ein Browser und eine Internetverbindung reichen aus. Spiele auf Desktop, Laptop, Chromebook, Smartphone, Tablet und mehr.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'Was sind die besten kostenlosen Spiele Online?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Welche Spiele kann ich mit Freunden online spielen?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Was sind die beliebtesten Game-Genres?',
    body: {
      text: [],
      list: [
        {
          name: 'Verrückte Spiele',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Brettspiele',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Abenteuerspiele',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Puzzlespiele',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Schießspiele',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Was ist Gamezop?',
    body: {
      text: [
        `Gamezop ist eine Plug-and-Play-Spieleplattform, die es Apps und Websites ermöglicht, Casual Games nahtlos zu integrieren und so die Nutzerbindung deutlich zu steigern. Neben Spielen betreibt Gamezop mehrere spezialisierte Plattformen: Quizzop für interaktive Quizze und Trivia, Astrozop für astrologische Einblicke und Vorhersagen, Criczop für Live-Cricket-Ergebnisse und Updates sowie Feedzop für kuratierte Nachrichteninhalte. Gemeinsam bieten diese Plattformen eine vielseitige Suite an Inhaltslösungen, die den unterschiedlichsten Interessen von Zielgruppen gerecht werden.`,
        `Mit über 8.000 Integrationen in mehr als 70 Ländern genießen Gamezop und seine zugehörigen Plattformen das Vertrauen globaler Marken wie Amazon, Samsung Internet, Snap, Tata Play, AccuWeather und Paytm. Diese Lösungen steigern nicht nur die Nutzerinteraktion, sondern eröffnen auch neue Einnahmequellen durch Werbung. Die Integration ist unkompliziert, dauert lediglich 30 Minuten und ermöglicht es Apps und Websites, ansprechende Inhalte bereitzustellen – von Spielen und Quizzen bis hin zu Astrologie, Cricket und Nachrichten.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'Häufig gestellte Fragen',
  faqs: [
    {
      tag: 'h3',
      title: 'Kann ich jedes Spiel kostenlos spielen, ohne es herunterzuladen oder zu installieren?',
      body: ['Ja, du kannst jedes Spiel kostenlos spielen, ohne es herunterzuladen oder zu installieren.'],
    },
    {
      tag: 'h3',
      title: 'Muss ich mich registrieren, um spielen zu können?',
      body: [
        'Nein, du musst dich nicht registrieren, um Spiele auf Gamezop.com zu spielen. Du kannst sofort und ohne Anmeldung loslegen.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/de',
      },
    },
    {
      tag: 'h3',
      title: 'Sind Online-Spiele sicher?',
      body: [
        'Ja, Online-Spiele sind sicher, wenn du auf vertrauenswürdigen Plattformen wie Gamezop spielst. Unsere Spiele erfordern weder Downloads noch Installationen, wodurch das Risiko von Malware erheblich reduziert wird. Wir achten besonders auf die Sicherheit der Nutzer und bieten ein geschütztes Spielerlebnis, ohne deine Privatsphäre oder Gerätesicherheit zu gefährden.',
      ],
    },
    {
      tag: 'h3',
      title: 'Sind kostenlose Online-Spiele wirklich kostenlos?',
      body: [
        'Ja, kostenlose Spiele sind auf Gamezop wirklich kostenlos spielbar. Allerdings können in diesen Spielen Anzeigen erscheinen, um die Plattform zu unterstützen.',
      ],
    },
    {
      tag: 'h3',
      title: 'Gibt es kostenlose Online-Spiele für Senioren?',
      body: [
        'Ja, wir haben kostenlose Spiele für Senioren, die online gespielt werden können. Dazu gehören Klassiker wie Sudoku Classic, Solitaire Gold, Chess Grandmaster und viele mehr.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
